<template>
    <v-container class="app-page-container">
        <v-card v-if = "test_info">
            <v-card-title>
                {{test_info.test_name}}
            </v-card-title>
            <v-card-text>
                <MemoryNumber v-if="test_info.id == 7"/>
                <Bartle v-if="test_info.id == 1"/>
                <ITQ v-if="test_info.id == 2"/>
                <Mackworth v-if="test_info.id == 8"/>
                <Vigilance v-if="test_info.id == 9"/>
                <Metakognicia v-if="test_info.id == 10"/>
                <Challenging v-if="test_info.id == 11"/>                
                <!-- <Test2 v-if="test_info.id == 2"/>             -->
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import axios from '../../axios-auth.js'
import MemoryNumber from '../../elements/person_tests/memory_number.vue'
import Bartle from '../../elements/person_tests/bartle.vue'
import ITQ from '../../elements/person_tests/itq.vue'
import Mackworth from '../../elements/person_tests/mackworth.vue'
import Vigilance from '../../elements/person_tests/vigilance.vue'
import Metakognicia from '../../elements/person_tests/metakognicia.vue'
import Challenging from '../../elements/person_tests/challenging_situations.vue'

// import Test2 from '../../elements/psycho_tests/cog_number_sep.vue'

export default {
    data() {
        return {
            test_type: 0,
            test_info: null
        }
    },
    mounted() {
        this.initData()
    },
    components: {
        MemoryNumber, Bartle, ITQ, Mackworth, Vigilance, Metakognicia, Challenging //, Test2
    },
    methods : {
        initData() {
            this.test_type = this.$route.params.id
            let _name = 'undefined'
            axios.get('/get-info-person-test/' + this.test_type, this.$store.getters.getAxiosConfig)
                .then(res => {
                    // set data to store
                    /* eslint-disable no-console */
                    // console.log(res.data)
                    if (res.data.message == 'OK') {
                        this.test_info = res.data.info[0]
                        _name = this.test_info.test_name
                    } else {
                        this.$store.commit('setFeedback', res.data.message)    
                    }
                    const bc = [ 
                        { text: 'Personalisation tests', href: '/person_tests/' },
                        { text: _name, href: '/person_test/' + this.test_type },
                    ]
                    this.$store.commit('setBreadCrumbs',bc)                        
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },
    }
}
</script>